export default function getAssigneeNames(assignees = []) {
  return assignees.map(assignee => `${assignee.firstName || ''} ${assignee.lastName || ''}`.trim()).join(', ');
}
